import { render, staticRenderFns } from "./BtnDownload.vue?vue&type=template&id=0dd95ac6&scoped=true&"
import script from "./BtnDownload.vue?vue&type=script&lang=js&"
export * from "./BtnDownload.vue?vue&type=script&lang=js&"
import style0 from "./BtnDownload.vue?vue&type=style&index=0&id=0dd95ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd95ac6",
  null
  
)

export default component.exports